const AUTH_KEY = 'pm_auth';
const PLAN_KEY = 'pm_selected_plan';
const PRO_TRIAL_USED_PREFIX = 'pm_pro_trial_used:';
const ELITE_DEV_EMAIL = 'iury.frx@gmail.com';

function normalizePlan(plan) {
  const normalized = (plan || '').toLowerCase().trim();
  return ['free', 'pro', 'elite'].includes(normalized) ? normalized : null;
}

function normalizeEmail(email) {
  return (email || '').toLowerCase().trim();
}

function getForcedPlanForEmail(email) {
  return normalizeEmail(email) === ELITE_DEV_EMAIL ? 'elite' : null;
}

function getCurrentAuthEmail() {
  return normalizeEmail(getAuth()?.user?.email);
}

function getProTrialKey(email) {
  const normalizedEmail = normalizeEmail(email) || getCurrentAuthEmail() || 'guest';
  return `${PRO_TRIAL_USED_PREFIX}${normalizedEmail}`;
}

export function saveAuth(token, user) {
  if (typeof window === 'undefined') return;
  const forcedPlan = getForcedPlanForEmail(user?.email);
  const nextUser = forcedPlan ? { ...(user || {}), plan: forcedPlan } : user;

  localStorage.setItem(AUTH_KEY, JSON.stringify({ token, user: nextUser }));
  localStorage.setItem('pm_onboarding_complete', nextUser?.onboarding_done ? 'true' : 'false');
  if (forcedPlan) {
    localStorage.setItem(PLAN_KEY, forcedPlan);
  }
  if (nextUser?.trial_used || nextUser?.pro_trial_used) {
    markProTrialUsed(nextUser?.email);
  }
}

export function getAuth() {
  if (typeof window === 'undefined') return null;
  try {
    return JSON.parse(localStorage.getItem(AUTH_KEY) || 'null');
  } catch {
    return null;
  }
}

export function clearAuth() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(PLAN_KEY);
  localStorage.removeItem('pm_onboarding_complete');
  localStorage.removeItem('pm_profile');
  localStorage.removeItem('pmb_token');
  localStorage.removeItem('pmb_study_plan');
  window.dispatchEvent(new Event('pm-auth-changed'));
}

export function getToken() {
  return getAuth()?.token || null;
}

export function getUser() {
  return getAuth()?.user || null;
}

export function getSelectedPlan() {
  if (typeof window === 'undefined') return null;
  const forcedPlan = getForcedPlanForEmail(getCurrentAuthEmail());
  if (forcedPlan) return forcedPlan;
  return normalizePlan(localStorage.getItem(PLAN_KEY));
}

export function patchAuthUser(patch) {
  if (typeof window === 'undefined') return null;
  const auth = getAuth();
  if (!auth) return null;

  const forcedPlan = getForcedPlanForEmail(auth?.user?.email || patch?.email);
  const nextUser = {
    ...(auth.user || {}),
    ...(patch || {}),
    ...(forcedPlan ? { plan: forcedPlan } : {}),
  };
  localStorage.setItem(AUTH_KEY, JSON.stringify({ ...auth, user: nextUser }));
  localStorage.setItem('pm_onboarding_complete', nextUser?.onboarding_done ? 'true' : 'false');
  if (forcedPlan) {
    localStorage.setItem(PLAN_KEY, forcedPlan);
  }
  window.dispatchEvent(new Event('pm-auth-changed'));
  return nextUser;
}

export function saveSelectedPlan(plan) {
  if (typeof window === 'undefined') return null;
  const forcedPlan = getForcedPlanForEmail(getCurrentAuthEmail());
  if (forcedPlan) {
    localStorage.setItem(PLAN_KEY, forcedPlan);
    patchAuthUser({ plan: forcedPlan });
    return forcedPlan;
  }
  const normalizedPlan = normalizePlan(plan);
  if (!normalizedPlan) return null;

  localStorage.setItem(PLAN_KEY, normalizedPlan);
  patchAuthUser({ plan: normalizedPlan });
  return normalizedPlan;
}

export function hasUsedProTrial(email) {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(getProTrialKey(email)) === 'true';
}

export function markProTrialUsed(email) {
  if (typeof window === 'undefined') return false;
  localStorage.setItem(getProTrialKey(email), 'true');
  window.dispatchEvent(new Event('pm-trial-changed'));
  return true;
}
